import { Shield, Award, FileCheck, Clock, DollarSign } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const Guarantees = () => {
  const guarantees = [
    {
      icon: Shield,
      title: "Garantía de Servicio",
      description: "6 meses en mano de obra"
    },
    {
      icon: Award,
      title: "Técnicos Certificados",
      description: "Instaladores SEC acreditados"
    },
    {
      icon: DollarSign,
      title: "Seguro de Responsabilidad Civil",
      description: "Cobertura hasta $50 millones"
    },
    {
      icon: FileCheck,
      title: "Respaldo Documental",
      description: "Informes técnicos detallados y certificados"
    },
    {
      icon: Clock,
      title: "Atención Rápida",
      description: "Respuesta en menos de 24 horas"
    }
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section via-industrial-gray/95 to-dark-section">
        <div className="absolute top-20 left-10 w-96 h-96 bg-green-500/20 rounded-full blur-3xl animate-liquid-blob opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            Tu Tranquilidad es Nuestra Prioridad
          </h2>
          <p className="text-lg text-white/70 text-center mb-12">
            Trabajamos con los más altos estándares de calidad y seguridad
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {guarantees.map((guarantee, index) => (
            <AnimatedSection
              key={index}
              animation="scale-in"
              delay={index * 50}
            >
              <div className="backdrop-blur-xl bg-white/10 border-2 border-green-500/30 rounded-2xl p-6 hover:bg-white/15 hover:border-green-500/50 transition-all duration-300 hover:scale-105 text-center">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-green-500/30 to-green-600/10 border-2 border-green-500/40 flex items-center justify-center mb-4 mx-auto shadow-liquid-lg">
                  <guarantee.icon className="w-8 h-8 text-green-400" />
                </div>
                
                <h3 className="text-lg font-montserrat font-bold text-white mb-2">
                  {guarantee.title}
                </h3>
                
                <p className="text-white/70 text-sm">
                  {guarantee.description}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Guarantees;
